import React, { useEffect } from "react";
import { GetServerSidePropsContext } from "next";
import Head from "next/head";
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";
import { useAppSelector } from "custom-hooks/redux.hooks";
import { CPagesPath } from "shared/models/const/pages-path";
import UserSettingsLayout from "shared/layouts/user-settings";
import styled from "@emotion/styled";
import FavoritesListInfinite from "@components-pages/favorites-properties/favorites-list-infinite";
import { FavActionMadeFromList } from "shared/context/show-fav-action-snackbar.context";
import { en,es} from "@lang"

export async function getServerSideProps({
  locale,
}: GetServerSidePropsContext) {
  return {
    props: {
      messages: locale === "es" ? es : en,
    },
  };
}

function FavoritesPage(props: any) {
  const titleT = useTranslations("title-pages");
  const t = useTranslations("ProfileFavoritesPage");
  const router = useRouter();
  const user = useAppSelector((state) => state.Auth.user);

  useEffect(() => {
    if (!user) router.push(CPagesPath.es.signin);
  });

  if (!user) return null;

  return (
    <>
      <Head>
        <title>{titleT("profile-favorites")}</title>
      </Head>
      <Container>
        <h1>{t("title")}</h1>
        <FavActionMadeFromList.Provider value={false}>
          <FavoritesListInfinite />
        </FavActionMadeFromList.Provider>
      </Container>
    </>
  );
}

FavoritesPage.Layout = UserSettingsLayout;

export default FavoritesPage;

const Container = styled.section`
  display: grid;
  place-content: center;
  grid-template-columns: 1fr;
  max-width: var(--list-max-width);
  margin: auto;
  padding: 30px 20px;

  h1 {
    color: var(--color-brand-blue-main);
  }
`;
